import { DEAL_TYPES } from 'client/site-modules/shared/components/deal/deal-constants';
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';

export const isDealTypeAvailable = ({ dealType, prices, inventoryType }) =>
  inventoryType && isUsed(inventoryType) && prices?.dealRatingIsCompliant && DEAL_TYPES.includes(dealType);
